import SolicitarAtendimento from '../components/SolicitarAtendimento.vue'

let routes = {
    path: '/sobre',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/solicitar-atendimento',
            name: 'SolicitarAtendimento',
            component: SolicitarAtendimento
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/solicitar_atendimento.js